// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    HTML_SITEMAP_POST_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPostPage: action.htmlSitemapPostPage
      };
    },
    HTML_SITEMAP_POST_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.htmlSitemapPostPage
      };
    },
    HTML_SITEMAP_POST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPostPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
